<script setup>
</script>

<template>
  <div
    class="relative min-h-screen w-full bg-[#161616] text-white flex flex-col justify-start pt-[var(--navbar-height)]"
  >
    <div class="mb-10 md:mb-16 w-full px-5 md:px-[263px] box-border">
      <div class="flex space-x-4 justify-center mt-8 md:mt-16">
        <router-link 
          :to="{ name: 'TermsOfUse' }"
          class="text-[#D0D0D1] hover:underline custom-underline font-regular"
          active-class="text-[#BFBCEC] underline" 
          exact
        >
          Terms of Use
        </router-link>

        <router-link 
          :to="{ name: 'PrivacyPolicy' }"
          class="text-[#D0D0D1] hover:underline custom-underline font-regular"
          active-class="text-[#BFBCEC] underline"
          exact
        >
          Privacy Policy
        </router-link>
      </div>
    </div>

    <div class="mx-5 md:mx-[263px]">
      <transition name="fade">
        <router-view />
      </transition>
    </div>

    <div
      class="hidden md:block absolute top-32 bottom-0 w-[1px] bg-[#FFFFFF] opacity-15"
      style="left: 263px;"
    ></div>

    <div
      class="hidden md:block absolute top-32 bottom-0 w-[1px] bg-[#FFFFFF] opacity-15"
      style="right: 263px;"
    ></div>

    <div
      class="absolute bottom-[60px] left-5 right-5 md:left-[60px] md:right-[60px] h-[1px] bg-white opacity-15"
    ></div>

    <div
      class="absolute bottom-0 left-0 w-[300px] h-[300px]
             bg-gradient-to-tr from-[#AA2FBE]/60 to-[#AA2FBE]/10
             filter blur-[200px]
             pointer-events-none"
    ></div>

    <footer class="footer font-light">
      © 2026 Sequreio App. All Rights Reserved.
    </footer>
  </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Albert+Sans:wght@300;400;500;700&display=swap');
</style>

<style scoped>
.custom-underline {
  text-decoration-thickness: 2px;
  text-underline-offset: 10px;
}

.font-light { font-family: 'Albert Sans', sans-serif; font-weight: 300; }
.font-regular { font-family: 'Albert Sans', sans-serif; font-weight: 400; }
.font-semibold { font-family: 'Albert Sans', sans-serif; font-weight: 500; }
.font-bold { font-family: 'Albert Sans', sans-serif; font-weight: 700; }

.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px; /* Slightly smaller for mobile footer */
  color: rgba(205, 207, 207, 0.9);
  padding: 20px 0;
  margin-top: 87px;
  background-color: transparent; /* Changed to transparent to sit over bg */
  width: 100%;
  line-height: 24px;
  z-index: 10; /* Ensure footer is above gradient */
}
</style>